import Loaders from './loaders';

export default Loaders;